"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var _MetaAPI = require("crm_data/meta/MetaAPI");

var _ObjectTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectTypes"));

var _MetaProducers = _interopRequireDefault(require("crm_data/meta/MetaProducers"));

var _CONTACT, _COMPANY, _objectTypesToProduce;

var CONTACT = _ObjectTypes.default.CONTACT,
    COMPANY = _ObjectTypes.default.COMPANY,
    DEAL = _ObjectTypes.default.DEAL,
    TICKET = _ObjectTypes.default.TICKET;
var COMPANY_ASSOCIATED_OPEN_DEALS = _MetaProducers.default.COMPANY_ASSOCIATED_OPEN_DEALS,
    COMPANY_ASSOCIATED_OPEN_TICKETS = _MetaProducers.default.COMPANY_ASSOCIATED_OPEN_TICKETS,
    CONTACT_ASSOCIATED_OPEN_DEALS = _MetaProducers.default.CONTACT_ASSOCIATED_OPEN_DEALS,
    CONTACT_ASSOCIATED_OPEN_TICKETS = _MetaProducers.default.CONTACT_ASSOCIATED_OPEN_TICKETS;
var URI = 'sales-views/v1/associated-open-objects';

var makeURI = function makeURI() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return URI + "/" + args.join('/');
};

var objectTypesToProducers = (_objectTypesToProduce = {}, (0, _defineProperty2.default)(_objectTypesToProduce, CONTACT, (_CONTACT = {}, (0, _defineProperty2.default)(_CONTACT, DEAL, CONTACT_ASSOCIATED_OPEN_DEALS), (0, _defineProperty2.default)(_CONTACT, TICKET, CONTACT_ASSOCIATED_OPEN_TICKETS), _CONTACT)), (0, _defineProperty2.default)(_objectTypesToProduce, COMPANY, (_COMPANY = {}, (0, _defineProperty2.default)(_COMPANY, DEAL, COMPANY_ASSOCIATED_OPEN_DEALS), (0, _defineProperty2.default)(_COMPANY, TICKET, COMPANY_ASSOCIATED_OPEN_TICKETS), _COMPANY)), _objectTypesToProduce);

function fetch(objectType, subjectId, objectTypeToFetch) {
  var fallback = function fallback() {
    return (0, _ImmutableAPI.get)(makeURI(objectType, subjectId, objectTypeToFetch));
  };

  return (0, _MetaAPI.queueFetch)(objectTypesToProducers[objectType][objectTypeToFetch], fallback, {
    objectIds: (0, _defineProperty2.default)({}, objectType, parseInt(subjectId, 10))
  });
}